"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityMenu = exports.EntityMenuDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var react_menu_1 = require("@szhsin/react-menu");
var ellipsis_button_1 = require("../elements/ellipsis-button");
var use_entity_update_modal_1 = require("../../hooks/use-entity-update-modal");
var use_modal_1 = require("../../hooks/use-modal");
var entity_delete_dialog_1 = require("./entity-delete-dialog");
var client_1 = require("@apollo/client");
var use_active_person_1 = require("../../hooks/use-active-person");
var use_app_screen_1 = require("../../hooks/use-app-screen");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var current_user_can_1 = require("../../utils/current-user-can");
var router_1 = require("@reach/router");
var lodash_1 = require("lodash");
var icon_1 = require("../elements/icon");
var icons_1 = require("../icons");
var menu_context_1 = require("../context/menu-context");
var route_1 = require("../../utils/route");
var current_path_name_1 = require("../../utils/current-path-name");
var react_spinners_1 = require("react-spinners");
var use_app_state_1 = require("../../hooks/use-app-state");
var use_copy_to_clipboard_1 = require("../../hooks/use-copy-to-clipboard");
var use_entity_1 = require("../../hooks/use-entity");
var PIN_ENTITY_MUTATION = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation PinEntityMutation($entityTypeName: String!, $id: String!) {\n    pinEntity(entityTypeName: $entityTypeName, id: $id) {\n      id\n      name\n      slug\n      openGraph { id image { id url } }\n      defaultPath\n      isWriteable\n      position\n      pinnedItems { \n        id\n        item {\n          id\n          entity {\n            id name slug\n            openGraph { \n              id\n              image { id url }\n            }\n          }\n        } \n      }\n    }\n  }\n"], ["\n  mutation PinEntityMutation($entityTypeName: String!, $id: String!) {\n    pinEntity(entityTypeName: $entityTypeName, id: $id) {\n      id\n      name\n      slug\n      openGraph { id image { id url } }\n      defaultPath\n      isWriteable\n      position\n      pinnedItems { \n        id\n        item {\n          id\n          entity {\n            id name slug\n            openGraph { \n              id\n              image { id url }\n            }\n          }\n        } \n      }\n    }\n  }\n"])));
exports.EntityMenuDefaultProps = {
  dotSize: 6,
  space: 0.75
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    z-index: 100;\n    .szh-menu {\n      border-radius: 0;\n      padding: 0;\n      box-shadow: 0 2px 5px -1px rgba(0, 0, 0, 0.1);\n      border: 1px solid ", ";\n      background: #FAFAFA;\n    }\n\n    .szh-menu__item {\n      font-family: ", ";\n      font-size: ", ";\n      font-weight: 500;\n      border-bottom: 1px solid ", ";\n      padding: ", " ", " ", " ", ";\n      text-transform: capitalize;\n      color: ", ";\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    .szh-menu__item--hover {\n      background-color: ", ";\n      color: ", ";\n      ", ";\n\n    }\n\n  "], ["\n    z-index: 100;\n    .szh-menu {\n      border-radius: 0;\n      padding: 0;\n      box-shadow: 0 2px 5px -1px rgba(0, 0, 0, 0.1);\n      border: 1px solid ", ";\n      background: #FAFAFA;\n    }\n\n    .szh-menu__item {\n      font-family: ", ";\n      font-size: ", ";\n      font-weight: 500;\n      border-bottom: 1px solid ", ";\n      padding: ", " ", " ", " ", ";\n      text-transform: capitalize;\n      color: ", ";\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    .szh-menu__item--hover {\n      background-color: ", ";\n      color: ", ";\n      ", ";\n\n    }\n\n  "])), theme_1.theme.COLOR('line-sidebar'), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(14), theme_1.theme.COLOR('line-sidebar'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('light'), theme_1.theme.FILL('light'))
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding: ", " 0 ", " ", ";\n    "], ["\n      padding: ", " 0 ", " ", ";\n    "])), theme_1.theme.UNIT(props._pad), theme_1.theme.UNIT(props._pad), theme_1.theme.UNIT(3));
  })
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.disabled && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      opacity: 0.2;\n      cursor: default;\n    "], ["\n      opacity: 0.2;\n      cursor: default;\n    "])));
  })
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-right: ", ";\n    ", ";\n  "], ["\n    margin-right: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.FILL('primary'))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(react_menu_1.Menu)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Controlled: (0, styled_components_1.default)(react_menu_1.ControlledMenu)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Button: (0, styled_components_1.default)(ellipsis_button_1.EllipsisButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Item: (0, styled_components_1.default)(react_menu_1.MenuItem)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var EntityMenu = function (props) {
  var className = props.className,
    entity = props.entity,
    buttonRef = props.buttonRef,
    sourceEntity = props.sourceEntity,
    isControlled = props.isControlled,
    ellipsisButtonProps = __rest(props, ["className", "entity", "buttonRef", "sourceEntity", "isControlled"]);
  var from = (0, current_path_name_1.currentPathName)();
  var _a = __read((0, react_1.useState)('open'), 2),
    state = _a[0],
    setState = _a[1];
  var _b = __read((0, use_copy_to_clipboard_1.useCopyToClipboard)(entity.slug), 2),
    copied = _b[0],
    copy = _b[1];
  var onCopySlugClick = function () {
    copy();
  };
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var dotSize = ellipsisButtonProps.dotSize;
  var buttonUnitPad = dotSize <= 6 ? 1 : 2;
  var t = (0, use_lang_1.useLang)();
  var client = (0, client_1.useApolloClient)();
  // TODO, replace this with a specific pinning hook
  var _c = __read((0, use_app_state_1.useAppState)(), 2),
    appState = _c[0],
    setAppState = _c[1];
  var pinning = appState.isPinning;
  var user = (0, use_active_person_1.useActivePerson)();
  var screen = (0, use_app_screen_1.useAppScreen)();
  var personId = (0, lodash_1.get)(user, 'person.id', '');
  var _d = __read((0, client_1.useMutation)(PIN_ENTITY_MUTATION), 1),
    pinQuery = _d[0];
  var detailsEntity = (0, use_entity_1.useEntity)();
  var _e = __read((0, client_1.useMutation)(defn.delete.mutation, {
      onError: function (error) {
        throw new Error(error.message);
      }
    }), 1),
    deleteMutation = _e[0];
  var onEditClick = (0, use_entity_update_modal_1.useEntityUpdateModal)(entity, {
    sourceEntity: sourceEntity !== entity && sourceEntity
  }).onClick;
  var modal = (0, use_modal_1.useModal)();
  var onEditClickRoute = function (event) {
    event.stopPropagation();
    event.preventDefault();
    (0, router_1.navigate)("/".concat((0, route_1.route)(defn.routes.update, {
      id: entity.id,
      _trailing: "from".concat(from, "/")
    })));
  };
  var _f = (0, menu_context_1.useMenuContext)(),
    portal = _f.portal,
    preventDelete = _f.preventDelete,
    expandedButton = _f.expandedButton,
    preventEdit = _f.preventEdit,
    useEditRoute = _f.useEditRoute,
    _g = _f.direction,
    direction = _g === void 0 ? "right" : _g,
    _h = _f.extraItems,
    extraItems = _h === void 0 ? [] : _h,
    items = _f.items;
  var onPinClick = function (event) {
    return __awaiter(void 0, void 0, void 0, function () {
      var data, newPerson;
      var _a, _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            event.stopPropagation();
            event.preventDefault();
            setAppState(__assign(__assign({}, appState), {
              isPinning: true
            }));
            return [4 /*yield*/, pinQuery({
              variables: {
                id: entity.id,
                entityTypeName: defn.name
              }
            })];
          case 1:
            data = _c.sent().data;
            newPerson = __assign(__assign({}, user.person), {
              pinnedItems: ((_a = data === null || data === void 0 ? void 0 : data.pinEntity) === null || _a === void 0 ? void 0 : _a.pinnedItems) || ((_b = user.person) === null || _b === void 0 ? void 0 : _b.pinnedItems) || []
            });
            setAppState(__assign(__assign({}, appState), {
              isPinning: false,
              activePerson: __assign(__assign({}, appState.activePerson), {
                person: newPerson
              })
            }));
            return [2 /*return*/];
        }
      });
    });
  };
  var onPinningClick = function (event) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        event.stopPropagation();
        event.preventDefault();
        return [2 /*return*/];
      });
    });
  };
  var onDeleteClick = function (event) {
    event.stopPropagation();
    event.preventDefault();
    modal.show(react_1.default.createElement(entity_delete_dialog_1.EntityDeleteDialog, {
      entity: entity,
      mutation: deleteMutation,
      onCancel: function () {
        return modal.hide();
      },
      onComplete: function (result) {
        modal.hide();
        if (screen.type === 'details' && screen.entityTypeName === defn.name && screen.slug === entity.slug) {
          (0, router_1.navigate)(defn.toList());
        }
        if (screen.type === 'list' && screen.entityTypeName === defn.name) {
          // this is a poor way to reload the list, but it works for now
          window.location.reload();
        }
        if (detailsEntity) {
          // if there is a master details entity, force it to relaad (we'll optimise this better later) 
          // console.log("EVICTING CACHE OBJECT", client.cache.identify(detailsEntity));
          client.cache.evict({
            id: client.cache.identify(detailsEntity)
          });
          client.cache.gc();
        }
      }
    }));
  };
  var portalElement = portal && portal.current;
  var canEdit = !entity.builtIn && defn.routes.update && !preventEdit && (0, current_user_can_1.personCanUpdate)(user, defn.scopeSlug);
  var canDelete = !entity.builtIn && defn.routes.update && !preventDelete && (0, current_user_can_1.personCanDelete)(user, defn.scopeSlug) && !(defn.name === 'Person' && entity && entity.id === personId) && !(defn.name === 'Person' && entity && entity.isMember) && !(defn.name === 'Person' && !(0, current_user_can_1.personCanAdmin)(user));
  var canAdmin = (0, current_user_can_1.personCanAdmin)(user, defn.scopeSlug);
  var existingPins = (user.person && user.person.pinnedItems || []).find(function (pin) {
    return "".concat((0, lodash_1.get)(pin, 'item.entity.__typename'), ":").concat((0, lodash_1.get)(pin, 'item.entity.id')) === "".concat(defn.name, ":").concat(entity && entity.id);
  });
  var canPin = defn.includeInSearch && !existingPins;
  var standardItems = (0, lodash_1.filter)([canEdit && {
    label: "".concat(t(defn.update.label), "..."),
    value: "EDIT",
    icon: react_1.default.createElement(icons_1.Icons.PencilCircle, null),
    onClick: useEditRoute ? onEditClickRoute : onEditClick
  }, canDelete && {
    label: "".concat(t(defn.delete.label), "..."),
    value: "DELETE",
    icon: react_1.default.createElement(icons_1.Icons.MinusCircle, null),
    onClick: onDeleteClick
  },
  // canAdmin && {
  //   label: 'Copy Platform Slug to Clipboard',
  //   value: "COPY_SLUG",
  //   icon: pinning ? <Spinner size={18} /> : <Icons.TargetCircle />,
  //   onClick: onCopySlugClick,
  // },
  canPin && {
    label: pinning ? 'Updating Pins. Please Wait...' : "Pin Item",
    value: "PIN",
    icon: pinning ? react_1.default.createElement(react_spinners_1.ClipLoader, {
      size: 18
    }) : react_1.default.createElement(icons_1.Icons.Entities.Pin, null),
    onClick: pinning ? onPinningClick : onPinClick
  }]);
  var menuItems = items && items.length ? items : __spreadArray(__spreadArray([], __read(standardItems), false), __read(extraItems), false);
  var onItemClick = function (event) {
    var item = menuItems.find(function (item) {
      return item.value === event.value;
    });
    if (item && item.onClick) {
      item.onClick(event.syntheticEvent);
    }
  };
  var swallowMouseDown = function (event) {
    event.stopPropagation();
  };
  var itemElements = react_1.default.useMemo(function () {
    return menuItems.map(function (item, index) {
      return react_1.default.createElement(My.Item, {
        disabled: item.disabled,
        onMouseDown: swallowMouseDown,
        key: "ITEM-".concat(item.value),
        value: item.value
      }, item.icon && react_1.default.createElement(My.Icon, {
        color: "primary",
        size: 24
      }, item.icon), item.label);
    });
  }, [user, entity, preventDelete, preventEdit]);
  if (!menuItems.length) {
    return null;
  }
  var Container = isControlled ? My.Controlled : My.Container;
  var extraContainerProps = isControlled ? {
    state: state
  } : {
    menuButton: react_1.default.createElement(My.Button, __assign({
      _pad: buttonUnitPad
    }, ellipsisButtonProps))
  };
  return /* @ts-ignore */react_1.default.createElement(Container, __assign({
    anchorRef: buttonRef,
    className: className,
    onItemClick: onItemClick,
    onClose: function () {
      return setState('closed');
    },
    color: "red",
    offsetX: 8,
    offsetY: -4,
    direction: direction,
    transition: true,
    portal: portalElement && {
      target: portalElement
    }
  }, extraContainerProps), itemElements);
};
exports.EntityMenu = EntityMenu;
exports.EntityMenu.defaultProps = exports.EntityMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;